import React from "react";
import {cx} from "../../lib/ClassSet";
import TrackingNr from "../../components/TrackingNr";
import ContextMenuTrigger from "../../components/ContextMenuTrigger";
import {hasShippingLabels} from "../../lib/Couriers";
import "./PackageTrackableItem.css";

const PackageTrackableItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "shipping-order-package-list-item": true,
    "u-selected": props.selected
  })
  let inventory = data.get("inventory").map(x => {
    return <span key={x.get("sku")}>{x.get("title")} ({x.get("sku")})</span>
  })
  let packaging = data.get("packaging").map(x => {
    return <span key={x.get("sku")}>{x.get("title")} ({x.get("sku")})</span>
  })
  let content = inventory.concat(packaging).toJS()
  let contextClickFn = (x, y) => props.onContextMenuClick(data, x, y)

  let downloadLabelEl = <span title="Labels are not available for this courier">N/A</span>;
  if (hasShippingLabels(data.get("courierId", props.courierId))) {
    downloadLabelEl = <span className="pdfIcon" name="Download label" onClick={(e) => props.onClick(data, e, "label")}></span>
  }


  return (
    <tr className={classes}>
      <td className="field f-packageId">{data.get("packageId")}</td>
      <td className="field f-tracking"><TrackingNr trackingNr={data.get("trackingNr")} courierId={data.get("courierId", props.courierId)} /></td>
      <td className="field">{data.get("dimensions")}<br/>{data.get("weight")}</td>
      <td className="field">{content}</td>
      <td className="field">{downloadLabelEl}</td>
      <td className="field f-context"><ContextMenuTrigger active={true} onClick={contextClickFn}/></td>
    </tr>
  )
}

export default PackageTrackableItem;